/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { QuickSearch } from "components/search";
import { useWindowSize } from "layout/homepage/useWindowSize";
import { NavLink } from "react-router-dom";

const MOBILE_SCREEN_WIDTH = 767;

const HeaderTopBar = () => {
    // TODO: SC-2340 - Add correct URLs to NavLink items
    // TODO: style search bar

    const { width } = useWindowSize();
    const isMobile = width <= MOBILE_SCREEN_WIDTH;

    return (
        <div className="header-top-bar">
            <div className="header-top-bar-content">
                <NavLink to="/">{isMobile ? "Contact" : "Contact Us"}</NavLink>
                <NavLink to="/">{isMobile ? "Report" : "Report an Issue"}</NavLink>
                <QuickSearch />
            </div>
        </div>
    );
};

export { HeaderTopBar };
